import e from "react";
import o from "./icons/CloseIcon.mjs";
import c from "./icons/HashtagIcon.mjs";
import a from "./icons/LockIcon.mjs";
/* empty css            */
const i = ({
  channel: t,
  updateConnectedChannels: n
}) => /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__connected_channel_tag" }, /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__connected_channel_tag__channel_type_icon" }, t.is_private ? /* @__PURE__ */ e.createElement(a, null) : /* @__PURE__ */ e.createElement(c, null)), /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__connected_channel_tag__text" }, t.name), /* @__PURE__ */ e.createElement("button", { onClick: () => n(t.id), className: "rsk-combobox__connected_channel_tag__delete_button" }, /* @__PURE__ */ e.createElement(o, null)));
export {
  i as default
};
//# sourceMappingURL=SlackConnectedChannelTag.mjs.map
